import { render, staticRenderFns } from "./programSetup.vue?vue&type=template&id=247ae601&"
import script from "./programSetup.vue?vue&type=script&lang=js&"
export * from "./programSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports